/**
 * @fileoverview Notification history query hook.
 * @description Wraps the notification-history API call in a TanStack query, for a consuming
 * project to build a notification list/bell UI on top of.
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Rahul Chawda
 */

import { useQuery } from '@tanstack/react-query'

import { getNotificationHistory } from '@/features/notifications/services/notifications.service'

export const NOTIFICATION_HISTORY_QUERY_KEY = ['notifications', 'history']

/**
 * @description Fetches the signed-in user's notification history.
 * @returns {ReturnType<typeof useQuery>} The query object (data, isPending, error, ...).
 */
export function useNotificationHistory() {
  return useQuery({
    queryKey: NOTIFICATION_HISTORY_QUERY_KEY,
    queryFn: getNotificationHistory,
  })
}
